import { registrationV2Slice, TwikeyResponseStatus } from "features/registration-v2/registrationV2Slice";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from 'react-router';
import { Background } from "screens/Background";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { TwikeySigningStatus } from "components/registration/TwikeySigningStatus";
import * as Sentry from '@sentry/react';
import { getParam } from "./registration/utils";
import { ReduxState } from "types";

/**
 * A TwikeyResponse object is built from the parameters read from the "thank you" page configured on Twikey console.
 * This "thank you" page address should point to a page on our website with the format:
 * .../twikey-callback-page?mandate-number={{mandateNumber}}&status={{status}}&account={{account}}&signature={{s}}&token={{token}}
 * More information about Twikey thank you page can be found here:
 * https://www.twikey.com/api/#thank-you-page
 * https://www.beta.twikey.com/support/creditor/settings/profiles/exiturl.html
 *
 * - the {token} is only represent when a new client completed the registration flow
 * - the {token} will be missing when an existing client signs a mandate!
*/

export const MandateSignedScreen = (props: Props) => {

    const [invalidQueryParams, setInvalidQueryParams] = useState<boolean>(false);

    const navigate = useNavigate();
    const location = useLocation();
    const { search } = location;
    const params = new URLSearchParams(search);

    const mandateNumber: string | undefined = getParam(params, 'mandate-number');
    const status: TwikeyResponseStatus | undefined = getParam(params, 'status') as TwikeyResponseStatus;
    const signature: string | undefined = getParam(params, 'signature');
    const registrationId: string | undefined = getParam(params, 'token');

    useEffect(() => {
        if (mandateNumber && status && signature) {
            props.processTwikeyResponse({ mandateNumber, status, signature, registrationId });
            if (registrationId) {
                navigate(`/registration-completed/`);
            }
        } else {
            setInvalidQueryParams(true);
            console.error('Could not process twikey signing as query parameters are missing');
            Sentry.captureException("Could not process twikey signing as query parameters are missing");
        }
    }, []);

    return (
        <Background>
            <div className="radius-rectangle settings-box">
                <div className="settings-box-content">
                    <TwikeySigningStatus invalidQueryParams={invalidQueryParams} registration={props.registration} />
                    <br />
                    <button className="btn-blue" onClick={() => navigate('/vehicles')}>
                        <FormattedMessage id="GLOBAL_CLOSE" />
                    </button>
                </div>
            </div>
        </Background>
    )
}


type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps;

/* istanbul ignore next */
function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        processTwikeyResponse: registrationV2Slice.actions.processTwikeyResponse
    }, dispatch);
}

function mapStateToProps(state: ReduxState) {
    return {
        registration: state.registration
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MandateSignedScreen);
